export default "__VITE_ASSET__BQJXCQBA__"